import { html } from "lit-element";
import { DrawSVGBaseModule } from "../../ModuleBase/svg-base-module";

export class DrawDvHor1Module extends DrawSVGBaseModule {
	constructor(canvas) {
		super(canvas);

		this.name = "dv-hor-1";
		this.icon = svg_dv_hor_1;
	}
}

window.customElements.define("inspx-draw-dv-hor-1-module", DrawDvHor1Module);

const svg_dv_hor_1 = html`
<svg width="60" height="30" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg">
 <g>
  <title>Layer 1</title>
  <rect id="svg_1" height="30" width="60.36658" fill="#ffffff" stroke="#444444" y="0" x="0"/>
  <line id="svg_2" y2="30" x2="30" y1="30" x1="0" stroke="#444444" fill="none"/>
  <line stroke="#444444" transform="rotate(-90.42057800292969 28.84895324707031,14.870086669921877) " id="svg_3" y2="14.87009" x2="43.84895" y1="14.87009" x1="13.84895" fill="none"/>
  <text stroke="#000000" transform="rotate(0.7744347453117371 28.864294052124084,14.774621963501005) matrix(1.75154344971287,0,0,1.2207685708999634,17.658567457324352,-25.567964295097863) " xml:space="preserve" text-anchor="middle" font-family="Sans-serif" font-size="24" id="svg_4" y="41.38184" x="6.34065" stroke-linecap="null" stroke-linejoin="null" stroke-dasharray="null" stroke-width="0" fill="#000000">DV</text>
  <line id="svg_5" stroke="#444444" transform="rotate(-90.42057800292969 60.16937255859375,15.401206970214847) " y2="15.40121" x2="75.16937" y1="15.40121" x1="45.16937" fill="none"/>
 </g>
</svg>`;
